import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {apiGetLeagueShow} from '../../../apis/league/getLeagueShow'

export const useQueryGetShowLeagues = (enabled?: boolean) => {
    const {data, refetch} = useQuery({
        enabled: enabled ?? true,
        queryKey: QueryCacheKeys.league.getLeagueShowLeague(),
        staleTime: 60 * 1000,
        queryFn: async () => {
            const {data} = await apiGetLeagueShow()
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}
